export default __webpack_public_path__ + "static/media/seat 2.9675038b.svg";